import { render, staticRenderFns } from "./edit-image-modal.vue?vue&type=template&id=15ec9bd5&"
import script from "./edit-image-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-image-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports